var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none",
    viewBox: "0 0 14 14",
    id: "svg1546"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M13.834 13.834a.569.569 0 000-.804L7.804 7l6.03-6.03a.567.567 0 10-.804-.803L7 6.196.97.166A.568.568 0 00.167.97L6.197 7l-6.03 6.03a.567.567 0 10.803.804L7 7.804l6.03 6.03a.569.569 0 00.804 0z",
    clipRule: "evenodd",
    id: "path1544",
    fillOpacity: 1
  })));
}
SvgClose.displayName = 'Close';
export default SvgClose;